import {ReactNode, useCallback} from 'react';
import {twMerge} from 'tailwind-merge';

import CheckMarkIcon from '@/assets/icons/check-mark.svg?react';

type PageLanguageSwitcherItemProps<T> = {
  code: T;
  name: string;
  selected: boolean;
  applying: boolean;
  onClick: (code: T) => void;
  icon?: ReactNode;
};

function PageLanguageSwitcherItem<T>({
  onClick,
  name,
  code,
  selected,
  applying,
  icon,
}: PageLanguageSwitcherItemProps<T>) {
  const handleClick = useCallback(() => {
    onClick(code);
  }, [onClick, code]);

  return (
    <button
      className={twMerge(
        'relative flex w-full overflow-hidden ps-4 text-start not-last:*:border-b-[0.5px] hover:bg-bg-gray',
        selected && 'bg-light-primary hover:bg-light-primary'
      )}
      onClick={handleClick}
    >
      <span className="flex w-full items-center justify-between gap-2 py-3 pe-4">
        <span
          aria-hidden
          className={twMerge(
            'pointer-events-none absolute top-1/2 left-1/2 aspect-square w-[150%] -translate-x-1/2 -translate-y-1/2 scale-0 rounded-full bg-light-primary transition-transform duration-700 ease-out',
            applying && 'scale-100'
          )}
        />
        <span className="relative flex items-center gap-2">
          {icon} {name}
        </span>
        {selected && <CheckMarkIcon className="relative text-link" />}
      </span>
    </button>
  );
}

export default PageLanguageSwitcherItem;
